import React, {useState, useEffect, useRef} from 'react';
import NavbarClean from '../components/NavbarClean';
import {EyeSlashIcon, EyeIcon} from '@heroicons/react/24/outline';
import {signInWithEmailAndPassword, sendPasswordResetEmail} from 'firebase/auth';
import {auth} from '../config/firebaseConfig';
import {useNavigate, NavLink} from 'react-router-dom';
import {motion} from 'framer-motion';
import AlertBox from '../components/AlertBox';
import { Toaster } from 'react-hot-toast';
import AlertOnLoading from '../components/AlertOnLoading';

function LoginPage() {
    const WARNING = "warning";
    const SUCCESS = "success";
    
    const WAIT_TIME = 1000; //Waits for 0.5s
    const notInitialRender = useRef(false);

    const [open, setOpen] = useState(false);

    const [loginPass, setLoginPass] = useState("");
    const [loginEmail, setLoginEmail] = useState("");
    const [forgetEmail, setForgetEmail] = useState("");

    const [shouldRedirect, setShouldRedirect] = useState(false);

    const navigate = useNavigate();

    const togglePopupForgot = () =>{
        [].forEach.bind(document.getElementsByClassName(`popup_forget`),function(itm){
          itm.style.display = "flex";
        })();
    }
  
    const closePopupForgot = () =>{
        [].forEach.bind(document.getElementsByClassName(`popup_forget`),function(itm){
            itm.style.display = "none";
        })();
    }


    async function logInUser() {
        try{
            const user = await signInWithEmailAndPassword(
                auth,
                loginEmail.trim(),
                loginPass
            );

            if (user) {
                setShouldRedirect(true);
            }
        }catch (e) {
            console.log(e.message);
            switch(e.message) {
                case "Firebase: Error (auth/invalid-email).":
                    AlertBox(WARNING, '¡Debe ingresar un correo electrónico válido!')
                    break;
                case "Firebase: Error (auth/user-not-found).":
                    AlertBox(WARNING, '¡El correo electrónico y/o la contraseña no coinciden con ningún usuario!')
                    break;
                case "Firebase: Error (auth/wrong-password).":
                    AlertBox(WARNING, '¡El correo electrónico y/o la contraseña no coinciden con ningún usuario!')
                    break;
                default:
                    AlertBox(WARNING, '¡Error desconocido mientras iniciaba sesión en su cuenta!')
                    break;
            } 
        }
    }

    async function forgotPasswordHandler() {
        if (forgetEmail === "") {
            AlertBox(WARNING, '¡Debe escribir un correo válido!');
            return;
        } else {
            await sendPasswordResetEmail(auth, forgetEmail)
            setLoginEmail("");
            closePopupForgot();
            setForgetEmail("");
            AlertBox(SUCCESS, 'Correo Enviado!');
            return;
        }
    }

    function submitHandler(e) {
        e.preventDefault();
        logInUser();
    }

    function toggle() {
        setOpen(!open);
    }

    useEffect(() => {
        if (notInitialRender.current && shouldRedirect){
            AlertOnLoading(WAIT_TIME+100, "Iniciando Sesión...");
            const interval = setInterval(() => { //Autorize re-render
                navigate('/');
                setShouldRedirect(false);
            }, WAIT_TIME);
            return () => clearInterval(interval);
            
        }else {
            notInitialRender.current = true;
        } 
      }, [shouldRedirect, navigate]);

    return (
        <div>
            <div>
                <Toaster
                toastOptions={{
                duration:3000,
            }}/> 
            </div>

            <NavbarClean />
            
            <form onSubmit={submitHandler} className='parent-section p-0 mx-0'>
                <div className='bg-white w-full h-screen flex overflow-hidden flex-col lg:flex-row'>
                    <motion.div 
                        className='space-y-3 w-full h-3/4 flex flex-col justify-center sm:space-y-4 items-center lg:w-3/5 lg:h-screen'
                        initial={{ opacity: 1, scale: 0.8}}
                        animate={{ opacity: 1, scale: 1}}
                        transition={{
                            type:"spring",
                            duration: 1,
                            ease: [0, 0.71, 0.2, 1.01],
                            stiffness:100
                        }}>
                        <h2 className="text-xl sm:text-2xl text-primary-100 font-bold form1:text-3xl">Iniciar Sesión</h2>
                        <p className="text-sm sm:text-base font-normal form1:text-xl">Para iniciar sesión rellena los siguientes datos</p>
                        <span className='w-4/5 border border-navFont-100 sm:w-2/3'></span>
                        
                        <div className='w-60 sm:w-80 relative shadow-sm form1:w-1/3'>
                            <input onChange={(ev) => {setLoginEmail(ev.target.value)}} type={'text'} placeholder="Correo Electrónico" 
                            className='text-sm sm:text-base w-full h-input-height py-2 px-3 text-input-font bg-primary-300 
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md' required/>
                        </div>
                        
                        <div className='w-60 sm:w-80 relative shadow-sm form1:w-1/3'>
                            <input onChange={(ev) => {setLoginPass(ev.target.value)}} type={(open === false)? "password":"text"} placeholder="Contraseña" 
                            className='w-full h-input-height py-2 pr-9 pl-3 text-input-font bg-primary-300 focus:outline-none 
                            focus:border focus:border-primary-100 focus:shadow-md text-sm sm:text-base' required/>

                            <div className='absolute inset-y-0 right-0 flex items-center hover:cursor-pointer'>
                                {
                                    (open === false)? <EyeSlashIcon onClick={toggle} className='text-input-font h-4 w-4 sm:h-6 sm:w-6 mx-2' />:
                                    <EyeIcon onClick={toggle} className='text-primary-100 h-4 w-4 sm:h-6 sm:w-6 mx-2' />
                                }
                            </div>
                        </div>
                        
                        <button type='button' onClick={togglePopupForgot} className='w-full h-8 text-xs sm:text-base sm:w-full sm:h-11 form1:text-xl hover:text-primary-100'>¿Olvidaste tu contraseña?</button>

                        <button id="sign-in-button" type={'submit'} className='w-28 h-8 text-sm sm:text-base sm:w-48 sm:h-11 bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200'>Ingresar</button>
                        
                    </motion.div>
                    <motion.div 
                        className='flex w-full h-1/4 lg:w-2/5 lg:h-screen bg-white bg-hero-access bg-no-repeat bg-cover relative -top-1'
                        initial={{ opacity: 1, x: "-10%" }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 1, x: "10%" }}
                        transition={{
                            type:"spring",
                            duration: 1,
                            ease: [0, 0.71, 0.2, 1.01],
                            stiffness:100
                        }}>
                        <div className='w-full flex flex-col justify-center items-center'>
                            <div className='w-auto h-auto bg-popup-alternative flex flex-col justify-center items-center p-5 space-y-3 sm:space-y-4 rounded-xl'>
                                <h2 className="text-xl sm:text-2xl text-white font-bold form1:text-3xl">¿Eres nuevo?</h2>
                                <p className="w-80 text-center text-sm sm:text-base font-normal text-white form1:text-xl form1:w-96">Si eres nuevo puedes crearte una cuenta,  para acceder a todos los beneficios.</p>
                                
                                <NavLink to="/Register" 
                                className='flex w-28 h-8 text-sm text-center items-center justify-center sm:text-base sm:w-48 sm:h-11 bg-white text-black rounded font-bold form1:text-xl
                                hover:text-primary-100 hover:bg-slate-50'>Registrarme</NavLink>
                            </div>
                        </div>
                        
                    </motion.div>
                </div>
            </form>

            <div className={`hidden relative z-40 popup_forget`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                <div className="fixed inset-0 bg-popup"></div>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                            <svg fill="#004080" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 416.979 416.979" stroke="#004080">

                                <g id="SVGRepo_bgCarrier" stroke-width="0"/>

                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>

                                <g id="SVGRepo_iconCarrier"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"/> </g> </g>

                            </svg>
                            </div>
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Olvidaste tu contraseña</h3>
                                <div className="mt-2">
                                <p className="text-sm text-gray-500">No te preocupes, ingresa tu correo electrónico para cambiar tu contraseña.</p>
                                <input onChange={(ev) => {setForgetEmail(ev.target.value)}} type={'text'} placeholder="Correo Electrónico" 
                                className='text-sm sm:text-base w-full h-input-height py-2 px-3 text-input-font bg-primary-300 
                                focus:outline-none focus:border focus:border-primary-100 focus:shadow-md mt-4' value={forgetEmail} required/>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            <button onClick={forgotPasswordHandler} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-primary-100 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-primary-200 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Aceptar</button>
                            <button onClick={closePopupForgot} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage
